import { render, staticRenderFns } from "./DeleteIcon.vue?vue&type=template&id=41276e34&scoped=true&"
var script = {}
import style0 from "./DeleteIcon.vue?vue&type=style&index=0&id=41276e34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41276e34",
  null
  
)

export default component.exports